import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";
var _templateObject, _templateObject2, _templateObject3, _templateObject4, _templateObject5, _templateObject6, _templateObject7, _templateObject8, _templateObject9, _templateObject10, _templateObject11, _templateObject12, _templateObject13, _templateObject14, _templateObject15, _templateObject16;
import styled from 'styled-components';
import Modal from '../../Modal';
import Box from '../../Box';
import Typography from '../../Typography';
import Icon from '../../Icon';
import { get } from '../../../styles/constant';
export const ConfigureModal = styled(Modal)(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n  width: 648px;\n  height: 648px;\n  max-height: 648px !important;\n"])));
export const Body = styled(Box)(_templateObject2 || (_templateObject2 = _taggedTemplateLiteral(["\n  display: flex;\n  justify-content: space-between;\n  height: 100%;\n"])));
export const LeftContent = styled(Box)(_templateObject3 || (_templateObject3 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.04),\n    0px 1px 18px rgba(0, 0, 0, 0.03), 0px 6px 10px rgba(0, 0, 0, 0.04);\n  border-radius: 4px;\n  background-color: ", ";\n  max-width: 12rem;\n  width: 100%;\n  overflow-y: auto;\n  cursor: default;\n"])), _ref => {
  let {
    theme
  } = _ref;
  return theme.colors.functional.grey['50'];
});
export const ContentHeader = styled(Typography)(_templateObject4 || (_templateObject4 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 700;\n  padding-left: 24px;\n  padding-top: 24px;\n"])), _ref2 => {
  let {
    theme
  } = _ref2;
  return theme.colors.functional.grey['900'];
});
export const LeftContentBody = styled(Typography)(_templateObject5 || (_templateObject5 = _taggedTemplateLiteral(["\n  color: ", ";\n"])), _ref3 => {
  let {
    theme
  } = _ref3;
  return theme.colors.functional.grey['900'];
});
export const LeftContentBodyValue = styled(Box)(_templateObject6 || (_templateObject6 = _taggedTemplateLiteral(["\n  box-sizing: border-box;\n  padding: 12px 24px;\n  white-space: nowrap;\n"])));
export const RightContent = styled(Box)(_templateObject7 || (_templateObject7 = _taggedTemplateLiteral(["\n  padding-top: 24px;\n  margin-left: 16px;\n  background-color: ", ";\n  overflow-y: auto;\n  box-shadow: 0px 3px 5px -1px rgba(0, 0, 0, 0.04),\n    0px 1px 18px rgba(0, 0, 0, 0.03), 0px 6px 10px rgba(0, 0, 0, 0.04);\n  border-radius: 4px;\n  width: 100%;\n"])), _ref4 => {
  let {
    theme
  } = _ref4;
  return theme.colors.functional.grey['50'];
});
export const RightContentHeader = styled(Typography)(_templateObject8 || (_templateObject8 = _taggedTemplateLiteral(["\n  color: ", ";\n  font-weight: 700;\n  padding: 24px;\n  margin-top: 24px;\n  position: relative;\n"])), _ref5 => {
  let {
    theme
  } = _ref5;
  return theme.colors.functional.grey['900'];
});
export const RightContentSearch = styled(Box)(_templateObject9 || (_templateObject9 = _taggedTemplateLiteral(["\n  margin: 12px 22px 0px 26px;\n"])));
export const RightContentBody = styled(Box)(_templateObject10 || (_templateObject10 = _taggedTemplateLiteral(["\n  display: flex;\n  flex-direction: column;\n"])));
export const RightContentRow = styled(Box)(_templateObject11 || (_templateObject11 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid #cfcfcf;\n  box-sizing: border-box;\n  box-shadow: 0px 1px 2px rgba(0, 0, 0, 0.1);\n  margin: 12px 22px 0px 26px;\n  padding: 8px 16px;\n"])));
export const RightContentRowIcons = styled(Box)(_templateObject12 || (_templateObject12 = _taggedTemplateLiteral(["\n  cursor: pointer;\n  display: flex;\n  align-content: center;\n  i:first-child {\n    margin-right: 0.5rem;\n  }\n"])));
export const RightContentItem = styled(Box)(_templateObject13 || (_templateObject13 = _taggedTemplateLiteral(["\n  font-size: ", ";\n  line-height: ", ";\n  color: ", ";\n"])), get('fontSizes.14'), get('lineHeights.16'), get('colors.functional.grey.900'));
export const ColumnIcon = styled(Icon)(_templateObject14 || (_templateObject14 = _taggedTemplateLiteral(["\n  color: ", ";\n  cursor: ", ";\n"])), _ref6 => {
  let {
    theme,
    isVisible
  } = _ref6;
  return isVisible ? theme.colors.primary.blue['300'] : '';
}, _ref7 => {
  let {
    disabled
  } = _ref7;
  return disabled ? 'not-allowed' : 'pointer';
});
export const RestoreButton = styled(Box)(_templateObject15 || (_templateObject15 = _taggedTemplateLiteral(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n"])));
export const RestoreButtonLabel = styled.span(_templateObject16 || (_templateObject16 = _taggedTemplateLiteral(["\n  text-decoration: underline;\n  color: ", ";\n"])), _ref8 => {
  let {
    theme
  } = _ref8;
  return theme.colors.feedback.danger.normal;
});